import React from "react";
import styles from "./DossierDashboard.module.scss";

const BenefitsCoverage = ({ stats }) => {
  const tracked = stats.benefits.filter((b) => b.total > 0);
  if (tracked.length === 0) return null;
  return (
    <div className={styles.sect} style={{ marginBottom: 4 }}>
      <div className={styles.sectTitle}>
        <span>Prestations</span>
      </div>
      {tracked.map((b) => {
        const full = b.covered === b.total;
        const none = b.covered === 0;
        return (
          <div key={b.key} className={styles.benefitRow}>
            <span>{b.label}</span>
            <span
              className={`${styles.benefitCount} ${
                full ? styles.benefitOk : !none ? styles.benefitWarn : ""
              }`}
            >
              {b.covered}/{b.total}
              {full && <i className="fa fa-check ml-1" />}
              {!full && !none && <span> hétérogène</span>}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default BenefitsCoverage;
